import { svg } from 'lit';

export const caretLeftIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L13.2929 18.7071C13.5789 18.9931 14.009 19.0786 14.3827 18.9238C14.7564 18.7691 15 18.4044 15 18V5.99997C15 5.59551 14.7564 5.23087 14.3827 5.07609C14.009 4.92131 13.5789 5.00686 13.2929 5.29286L7.29289 11.2929Z" fill="currentColor"/>
  `;
